import { ModelsTemplates } from "@resources/models-fetch/ModelsFetch";

export const atempl = new ModelsTemplates({
	endpoint: atnlbs_default.wp_rest_url + "apimodels/v0",
	attr: "atempl",
})
